import { h } from "preact";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
	},
}));

export default function GesC({ nb }) {
	const classes = useStyles();

	return (
		<svg width="200px" height="240px" viewBox="0 0 346 479" version="1.1">
			<title>GES</title>
			<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g id="GES" transform="translate(1.000000, 1.000000)">
					<g id="mire-C" transform="translate(162.000000, 169.214286)">
						<rect id="Rectangle" stroke="#000000" stroke-width="4" x="114" y="7" width="82" height="46"></rect>
						<line
							x1="112.5"
							y1="30.5"
							x2="0.5"
							y2="30.5"
							id="Line"
							stroke="#000000"
							stroke-width="4"
							stroke-linecap="square"
							stroke-dasharray="15"
						></line>
						<text id="lbl" font-family="SourceSansRoman-Semibold, Source Sans Variable" font-size="48" font-weight="500" fill="#000000">
							<tspan x="129.041738" y="47">
								{nb}
							</tspan>
						</text>
					</g>
					<g fill-rule="nonzero">
						<text
							id="Emissions-de-gaz-à-e"
							fill="#000000"
							font-family="SourceSansRoman-Bold, Source Sans Variable"
							font-size="24"
							font-weight="bold"
						>
							<tspan x="0" y="23.1696429">
								Emissions de gaz à effet de serre
							</tspan>
						</text>
						<text
							id="en-kgeqCO2/m²/an"
							fill="#000000"
							font-family="SourceSansRoman-Bold, Source Sans Variable"
							font-size="24"
							font-weight="bold"
						>
							<tspan x="0" y="51.5625">
								en kgeqCO2/m²/an
							</tspan>
						</text>
						<polygon
							id="Path"
							stroke="#000000"
							fill="#FAEEFF"
							points="0 60.5714286 0 107.892857 121.624193 107.892857 122 60.5714286"
						></polygon>
						<polygon id="Path" stroke="#000000" fill="#EBBDFF" points="0 117.357143 0 164.678571 143 164.678571 143 117.357143"></polygon>
						<polygon id="Path" stroke="#000000" fill="#DDA3FC" points="0 174.142857 0 221.464286 164 221.464286 164 174.142857"></polygon>
						<polygon id="Path" stroke="#000000" fill="#D891FC" points="0 230.928571 0 278.25 186 278.25 186 230.928571"></polygon>
						<polygon id="Path" stroke="#000000" fill="#C86BF5" points="0 287.714286 0 335.035714 207 335.035714 207 287.714286"></polygon>
						<polygon id="Path" stroke="#000000" fill="#BB3DF6" points="0 344.5 0 391.821429 228 391.821429 228 344.5"></polygon>
						<polygon id="Path" stroke="#000000" fill="#9900E8" points="0 401.285714 0 448.607143 249 448.607143 249 401.285714"></polygon>
						<text id="A" fill="#000000" font-family="SourceSansRoman-Bold, Source Sans Variable" font-size="36" font-weight="bold">
							<tspan x="74" y="97.2053571">
								A
							</tspan>
						</text>
						<text id="B" fill="#000000" font-family="SourceSansRoman-Bold, Source Sans Variable" font-size="36" font-weight="bold">
							<tspan x="95" y="153.991071">
								B
							</tspan>
						</text>
						<text id="C" fill="#000000" font-family="SourceSansRoman-Bold, Source Sans Variable" font-size="36" font-weight="bold">
							<tspan x="117" y="210.776786">
								C
							</tspan>
						</text>
						<text id="D" fill="#000000" font-family="SourceSansRoman-Bold, Source Sans Variable" font-size="36" font-weight="bold">
							<tspan x="138" y="267.5625">
								D
							</tspan>
						</text>
						<text id="E" fill="#000000" font-family="SourceSansRoman-Bold, Source Sans Variable" font-size="36" font-weight="bold">
							<tspan x="159" y="324.348214">
								E
							</tspan>
						</text>
						<text id="F" fill="#000000" font-family="SourceSansRoman-Bold, Source Sans Variable" font-size="36" font-weight="bold">
							<tspan x="180" y="381.133929">
								F
							</tspan>
						</text>
						<text id="G" fill="#000000" font-family="SourceSansRoman-Bold, Source Sans Variable" font-size="36" font-weight="bold">
							<tspan x="201" y="437.919643">
								G
							</tspan>
						</text>
						<text id="≤-5" fill="#000000" font-family="SourceSansRoman-Bold, Source Sans Variable" font-size="20" font-weight="bold">
							<tspan x="10" y="93">
								&lt; 6
							</tspan>
						</text>
						<text id="6-à-10" fill="#000000" font-family="SourceSansRoman-Bold, Source Sans Variable" font-size="20" font-weight="bold">
							<tspan x="10" y="150">
								6 à 11
							</tspan>
						</text>
						<text id="11-à-20" fill="#000000" font-family="SourceSansRoman-Bold, Source Sans Variable" font-size="20" font-weight="bold">
							<tspan x="10" y="208">
								11 à 30
							</tspan>
						</text>
						<text id="21-à-35" fill="#000000" font-family="SourceSansRoman-Bold, Source Sans Variable" font-size="20" font-weight="bold">
							<tspan x="10" y="262">
								30 à 50
							</tspan>
						</text>
						<text id="26-à-55" fill="#000000" font-family="SourceSansRoman-Bold, Source Sans Variable" font-size="20" font-weight="bold">
							<tspan x="10" y="320">
								50 à 70
							</tspan>
						</text>
						<text id="56-à-80" fill="#000000" font-family="SourceSansRoman-Bold, Source Sans Variable" font-size="20" font-weight="bold">
							<tspan x="10" y="378">
								70 à 100
							</tspan>
						</text>
						<text id="&gt;-80" fill="#000000" font-family="SourceSansRoman-Bold, Source Sans Variable" font-size="20" font-weight="bold">
							<tspan x="10" y="432">
								&gt; 100
							</tspan>
						</text>
					</g>
				</g>
			</g>
		</svg>
	);
}
